import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { RouterProvider } from "./lib/router";
import "./styles.css";

const density = localStorage.getItem("tds-density");
const reducedMotion = localStorage.getItem("tds-reduce-motion");
if (density) document.documentElement.dataset.density = density;
if (reducedMotion) document.documentElement.dataset.reduceMotion = reducedMotion;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider>
        <App />
      </RouterProvider>
    </QueryClientProvider>
  </StrictMode>,
);
